/**
 * Glide.js slider
 * config options can be found here: https://glidejs.com/docs/options/
 */
import Glide from '@glidejs/glide';
//This function is used to create a Glide.js slider. It accepts a selector and config
export default function createSlider(selector, config) {
	new Glide(selector, config).mount();
}
